// extracted by mini-css-extract-plugin
module.exports = {"colors":"index_colors__I20fv"};